import { t } from "i18next";
import * as Yup from "yup";

import { getRandomDefaultColor } from "@/utils/UColors";

import { TViewEditFormValues } from "@/types";

export const ViewEditFormInitialValues: TViewEditFormValues = {
	name: "",
	color: getRandomDefaultColor(),
	description: "",
	type: "calendar",
	projects: [],
	clients: [],
};

export const ViewEditFormValidation = () => {
	return Yup.object().shape({
		name: Yup.string().required(t("views.validation.name")),
		color: Yup.string().required(t("views.validation.color")),
	});
};
